import { forwardRef } from "react";
import { Icon, type IconProps } from "../Icon";

export const Amazon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <Icon ref={ref} {...props}>
      <path d="M21 18.5c-2.5 1.8-6 2.8-9 2.8-4.3 0-8.1-1.6-11-4.2-.2-.2 0-.5.3-.3 3.6 2.1 8.1 3.4 12.7 3.4 3.1 0 6.5-.6 9.6-2 .5-.2.9.3.4.7z" />
      <path d="M22 17.2c-.3-.4-2.1-.2-2.9-.1-.2 0-.3-.2 0-.3 1.4-1 3.7-.7 4-.4.3.4-.1 2.8-1.5 4-.2.2-.4.1-.3-.1.3-.7.9-2.3.6-2.7z" />
      <path d="M19.7 10.5c-.7-.9-1.5-1.7-1.5-3.4 0-2.9 2.2-4.5 5.3-4.5v1.5c-2 0-3.3.9-3.3 2.6 0 1.4.4 2.1 1.2 3 .8.8 1.3 1.8 1.3 3.2 0 2.8-2.3 4.5-5.5 4.5-3 0-4.9-1.1-4.9-2.7 0-1.5 1-2 1.5-2s.9.1 1.1.6c-.3 1.5.7 2.1 2.2 2.1 1.4 0 2.3-.9 2.3-2.2 0-1.1-.5-1.8-1.2-2.6zM10 18H4c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h6v2H5v8h5z" />
    </Icon>
  );
});

Amazon.displayName = "Amazon";
